import Renderer from '../MDRenderer/renderer.js'
import CodeMirror, { EditorView } from '@uiw/react-codemirror';
import { markdown, markdownLanguage } from '@codemirror/lang-markdown';
import { languages } from '@codemirror/language-data';

import React, { useState } from 'react';
import './editor.css'


export default function Editor({closeEditor, targetID, blocksData, setBlocksData}){    
    const target_data = blocksData['blocks'][targetID]

    const [content, setContent] = useState(target_data?.content || "");

    const updateBlock = () => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['content'] = content
        setBlocksData(clone)
        closeEditor()
    }

    return (
        <>
            <h2>Editor</h2>
            <div style={{"height": "85%"}}>
                <div className='split Left'>
                    <CodeMirror  
                        height="100%" 
                        value={content} 
                        onChange={(content) => setContent(content)}
                        extensions={[markdown({ base: markdownLanguage, codeLanguages: languages }), EditorView.lineWrapping]}/>
                </div>
                <div className="split Right">
                    <Renderer content = {content}/>
                </div>
            </div>
            <button style={{"marginTop": "8px", "float": "right", "backgroundColor": "#faec91"}}onClick={updateBlock}>Save + Close</button>

        </>
    )
}